import { Select, Spin } from "antd";
import React, { useState } from "react";
import Error from "../Error";
import PlusButton from "../Buttons/plus";
import { useNavigate } from "react-router-dom";
import { select_search } from "../../Controllers/Global";
import toast from "react-hot-toast";
import { Modal } from "antd";

import ProductsForm from "../../Pages/Products/Products/Form";
import ProductunitsForm from "../../Pages/Products/Units/Form";
import ProductcategoriesForm from "../../Pages/Products/Categories/Form";
import ProductbrandsForm from "../../Pages/Products/Brands/Form";

import ServiceForm from "../../Pages/Services/Services/Form";
import ServicecategoriesForm from "../../Pages/Services/Categories/Form";

import InventoryBatchForm from "../../Pages/Inventory/Batch/Form";
import InventoryTransferForm from "../../Pages/Inventory/Transfer/Form";
import InventoryReceivedForm from "../../Pages/Inventory/Received/Form";
import InventoryRequestForm from "../../Pages/Inventory/Request/Form";
import InventoryRequestedForm from "../../Pages/Inventory/Requested/Form";
import InventoryExpiryForm from "../../Pages/Inventory/Expiry/Form";

import BillingForm from "../../Pages/Billings/Billings/Form";
import BillingsFormSales from "../../Pages/Billings/Billings/Form/sales";
import BillingsReturnsForm from "../../Pages/Billings/Returns/Form";

import CreditNotesForm from "../../Pages/Sales/CreditNote/Form";
import SOForm from "../../Pages/Sales/SO/Form";
import DOForm from "../../Pages/Sales/DO/Form";
import SalesOrderForm from "../../Pages/Sales/Invoices/Form";
import SalesQuotesForm from "../../Pages/Sales/Quotes/Form";
import SalesReturnsForm from "../../Pages/Sales/Returns/Form";

import LpoForm from "../../Pages/Purchases/Lpos/Form";
import PurchasesOrderForm from "../../Pages/Purchases/Order/Form";
import VoucherForm from "../../Pages/Purchases/Voucher/Form";
import DebitNotesForm from "../../Pages/Purchases/DebitNotes/Form";
import PurchasesReturnsForm from "../../Pages/Purchases/Returns/Form";
import PurchasesReceivedForm from "../../Pages/Purchases/Received/Form";
import PurchasesPaidForm from "../../Pages/Purchases/Paid/Form";
import PurchasesReturnForm from "../../Pages/Purchases/Return/Form";
import PurchasesSentForm from "../../Pages/Purchases/Sent/Form";
import PurchasesRefundForm from "../../Pages/Purchases/Refund/Form";
import MaterialRequestForm  from "../../Pages/Purchases/MaterialRequest/Form"

import ExpensesForm from "../../Pages/Expenses/Expenses/Form";
import ExpensecategoriesForm from "../../Pages/Expenses/Categories/Form";

import CustomersForm from "../../Pages/Customers/Customers/Form";
import SalesManForm from "../../Pages/SalesMan/Form";
import RefrencesForm from "../../Pages/Customers/References/Form";

import SuppliersForm from "../../Pages/Suppliers/Suppliers/Form";

import FeatureUnlockModal from "../../Pages/FeatureLocks/Form";

import TaxForm from "../../Pages/Settings/Tax/Tax/Form";
import TaxTypeForm from "../../Pages/Settings/Tax/Tax_Types/Form";
import RoutingForm from "../../Pages/Settings/Routing/Form";

import ImportForm from "../../Pages/Settings/Import/Form";

import UsersForm from "../../Pages/Settings/Users/Form";
import BranchesForm from "../../Pages/Settings/Branches/Form";
import RolesForm from "../../Pages/Settings/Roles/Form";

import ChartOfAccountsForm from "../../Pages/Accounting/DoubleEntry/ChartofAccounts/Form";
import ManualJournalForm from "../../Pages/Accounting/DoubleEntry/ManualJournalEntry/Form";

const Selectaddcomponent = React.forwardRef((props, focus) => {
  const addRouteMap = {
    "/app/products/add": ProductsForm,
    "/app/products/units/add": ProductunitsForm,
    "/app/products/categories/add": ProductcategoriesForm,
    "/app/products/brands/add": ProductbrandsForm,

    "/app/services/add": ServiceForm,
    "/app/services/categories/add": ServicecategoriesForm,

    "/app/inventory/add": InventoryBatchForm,
    "/app/inventory/transfer/add": InventoryTransferForm,
    "/app/inventory/received/add": InventoryReceivedForm,
    "/app/inventory/request/add": InventoryRequestForm,
    "/app/inventory/requested/add": InventoryRequestedForm,
    "/app/inventory/expiry/add": InventoryExpiryForm,

    "/app/billing/add": BillingForm,
    "/app/billing/new/add": BillingsFormSales,
    "/app/billing/returns/add": BillingsReturnsForm,

    "/app/sales/credit-notes/add": CreditNotesForm,
    "/app/sales/sales-order/add": SOForm,
    "/app/sales/delivery-note/add": DOForm,
    "/app/sales/add": SalesOrderForm,
    "/app/sales/quotes/add": SalesQuotesForm,
    "/app/sales/invoices/add": SalesOrderForm,
    "/app/sales/returns/add": SalesReturnsForm,

    "/app/purchases/lpo/add": LpoForm,
    "/app/purchases/add": PurchasesOrderForm,
    "/app/purchases/orders/add": PurchasesOrderForm,
    "/app/purchases/voucher/add": VoucherForm,
    "/app/purchases/debit-notes/add": DebitNotesForm,
    "/app/purchases/returns/add": PurchasesReturnsForm,
    "/app/purchases/received/add": PurchasesReceivedForm,
    "/app/purchases/paid/add": PurchasesPaidForm,
    "/app/purchases/return/add": PurchasesReturnForm,
    "/app/purchases/sent/add": PurchasesSentForm,
    "/app/purchases/refund/add": PurchasesRefundForm,
    "/app/purchases/mrn/add":MaterialRequestForm,

    "/app/expenses/add": ExpensesForm,
    "/app/expenses/categories/add": ExpensecategoriesForm,

    "/app/customers/add": CustomersForm,
    "/app/customers/refrences/add": RefrencesForm,

    "/app/salesman/add": SalesManForm,

    "/app/suppliers/add": SuppliersForm,

    "/app/feature-lock/add": FeatureUnlockModal,

    "/app/settings/tax/add": TaxForm,
    "/app/settings/tax/types/add": TaxTypeForm,
    "/app/settings/routing/add": RoutingForm,

    "/app/settings/users/add": UsersForm,
    "/app/settings/branches/add": BranchesForm,
    "/app/settings/roles/add": RolesForm,

    "/app/accounting/chart-of-accounts/add": ChartOfAccountsForm,
    "/app/manual-journals/add": ManualJournalForm,
  };

  const { index, ind, val, form, setForm, getFormdata } = props;
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [DynamicComponent, setDynamicComponent] = useState(null);

  let navigate = useNavigate();

  const handleSelect = (e, index, ind) => {
    let data = [...form];

    data[index].options[ind].form.value = e;

    if (data[index]?.options[ind]?.show?.check) {
      data?.map((value, k) => {
        value?.options?.map((val, i) => {
          if (val?.show?.name == data[index].options[ind].form.name) {
            data[k].options[i].show.status = e ? true : false;
          }
        });
      });
    }

    setForm(data);
    getFormdata(data);
  };

  const handleSearch = async (e, index, ind) => {
    setLoader(true);

    let data = [...form];

    const select = !data[index].options[ind].form.api
      ? { ...data[index].options[ind].form.params }
      : {
        api: data[index].options[ind].form.api,
        search: e,
        status: 1,
      };

    const search = await select_search(select);

    if (search?.status) {
      let options = [];

      if (data[index].options[ind].form.name == "customer") {
        search?.data?.data?.map((value, index) => {
          options?.push({
            value: value?._id,
            label:
              value?.name && value?.code && value?.phone
                ? value?.code + " " + value?.name + " (" + value?.phone + ")"
                : value?.name && value?.code
                  ? value?.code + " " + value?.name
                  : value?.phone && value?.code
                    ? value?.code + " (" + value?.phone + ")"
                    : value?.name && value?.phone
                      ? value?.name + " (" + value?.phone + ")"
                      : value?.name
                        ? value?.name
                        : value?.phone
                          ? value?.phone
                          : "",
          });
        });
      } else {
        search?.data?.data?.map((value, index) => {
          options?.push({ value: value?._id, label: value?.name ? value?.name : value?.number });
        });
      }

      data[index].options[ind].form.options = options;

      setForm(data);
      getFormdata(data);
      setLoader(false);
    } else {
      toast?.error(search?.message);
      setLoader(false);
    }
  };

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const handleOpenComponent = () => {
    const Comp = addRouteMap[val?.path];
    console.log("val?.path", val);

    if (Comp) {
      setDynamicComponent(() => Comp);
      setOpen(true);
    }
  };

  return (
    <React.Fragment>
      <div className="flex w-full">
        <div className="flex-grow w-full">
          <Select
            key={index}
            id={index?.toString()?.concat(ind)}
            name={val?.form?.name}
            placeholder={val?.form?.placeholder}
            className={
              val?.form?.className
                ? val?.form?.className
                : "text-regular w-full"
            }
            ref={focus.current[val?.form?.name?.concat(index + "" + ind)]}
            size={val?.form?.size}
            mode={val?.form?.mode}
            allowClear={val?.form?.allowClear}
            showSearch={val?.form?.showSearch}
            filterOption={val?.form?.filterOption}
            disabled={val?.form?.disabled ? val?.form?.disabled : false}
            options={val?.form?.options}
            value={val?.form?.value}
            onKeyDown={handleOnKeyDown}
            onClick={() => handleSearch("", index, ind)}
            onFocus={() => handleSearch("", index, ind)}
            onSearch={(e) => handleSearch(e, index, ind)}
            onChange={(e) => handleSelect(e, index, ind)}
          />
        </div>
        <div className="pl-3">
          <PlusButton onClick={handleOpenComponent} />
        </div>
        <Modal
          open={open}
          onCancel={() => setOpen(false)}
          footer={null}
          className="select-add-modal"
          getContainer={document.body}
          styles={{
            body: {
              padding: 0,
              margin: 0,
            },
            content: {
              padding: 0,
            },
          }}
        >
          {DynamicComponent && (
            <div className="modal-form-wrapper"
              onClick={(e) => e.stopPropagation()}
              onSubmit={(e) => e.stopPropagation()}
            >
              <DynamicComponent
                isModal={true}
                onClose={() => {
                  setOpen(false);
                  handleSearch("", index, ind);
                }}
              />
            </div>
          )}
        </Modal>
      </div>
      <Error id={val?.form?.name?.concat(index + "" + ind)} />
    </React.Fragment>
  );
});

export default Selectaddcomponent;
